module.exports = __webpack_public_path__ + "img/24_24.ee46e34c.png";